// extracted by mini-css-extract-plugin
export default {"Backdrop":"Modal_Backdrop__+-+qH","Modal":"Modal_Modal__nf9ki","Button":"Modal_Button__nwZKA"};